import { render, staticRenderFns } from "./record.vue?vue&type=template&id=7c927154&scoped=true&"
import script from "./record.js?vue&type=script&lang=js&"
export * from "./record.js?vue&type=script&lang=js&"
import style0 from "./record.css?vue&type=style&index=0&id=7c927154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c927154",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
